import React, {
  useMemo, useState, useCallback, useEffect,
} from 'react';
import PropTypes from 'prop-types';

import {
  CellContainer,
  Tooltip,
} from './styles';

const Cell = (props) => {
  const {
    value,
    col,
    row,
    total,
    onChangeVisible,
  } = props;

  const [visible, setVisible] = useState(false);

  const rawValue = useMemo(() => Math.trunc(value * 100), [value]);
  const participantsCount = useMemo(() => Math.trunc(value * total), [value, total]);

  const handleHover = useCallback(() => {
    setVisible(true);
  }, [setVisible]);

  const handleOut = useCallback(() => {
    setVisible(false);
  }, [setVisible]);

  useEffect(() => {
    if (visible) {
      onChangeVisible(col);
    }
  }, [visible]);

  return (
    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
    <CellContainer opacity={value} onMouseEnter={handleHover} onMouseLeave={handleOut}>
      {rawValue}
      {visible && (
        <Tooltip>
          {col}
          &nbsp;
          and
          &nbsp;
          {row}
          &nbsp;
          were grouped together by
          &nbsp;
          {rawValue}
          % of participants (
          {participantsCount}
          &nbsp;
          participants)
        </Tooltip>
      )}
    </CellContainer>
  );
};

Cell.propTypes = {
  value: PropTypes.string.isRequired,
  col: PropTypes.string.isRequired,
  row: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  onChangeVisible: PropTypes.func.isRequired,
};

export default Cell;
